import { render, staticRenderFns } from "./HrHirePerson.vue?vue&type=template&id=1c4498bc&scoped=true&"
import script from "./HrHirePerson.vue?vue&type=script&lang=js&"
export * from "./HrHirePerson.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4498bc",
  null
  
)

export default component.exports